export default __webpack_public_path__ + "static/Personajes_familia-625fd1d70b29c04cb0ff0c6031c40069.png";